module.exports = "<p>\r\n  reportassignment works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reportassignment/reportassignment/reportassignment.component.html
// module id = ./src/app/reportassignment/reportassignment/reportassignment.component.html
// module chunks = main